import { render, staticRenderFns } from "./annex-import-list.vue?vue&type=template&id=596c2b98&scoped=true"
import script from "./annex-import-list.vue?vue&type=script&lang=ts"
export * from "./annex-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c2b98",
  null
  
)

export default component.exports